import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate"
import ExportSVG from '../icon/ExportSVG'
import { downloadExcel } from "react-export-table-to-excel";
import Loading from "../Loading"

function CompanyMobile() {
    const { companyName } = useParams();
    const [pageData, setpageData] = useState({});
    const [anuual, setAnnual] = useState(false);
    const [collapse, setCollapse] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const [companySymbol, setcompanySymbol] = useState('');
    if (companyName != companySymbol) {
        setAnnual(false)
        setcompanySymbol(companyName)
    }

    function dynamicSortDescending(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            console.log(a[property])
            console.log(b[property])
            var result = (parseFloat(forceDefault(a[property])) > parseFloat(forceDefault(b[property]))) ? -1 : (parseFloat(forceDefault(a[property])) < parseFloat(forceDefault(b[property]))) ? 1 : 0;
            return result * sortOrder;
        }
    }

    function forceDefault(data) {
        if (data === "-") {
            return 0
        } else {
            return data
        }
    }
    const companyDetails = async () => {
        setpageData({})
        let url = ""
        url = process.env.REACT_APP_BASE_URL + "/v1/shareholdings/" + companySymbol + "?annual=" + anuual + "&access_token=" + process.env.REACT_APP_DATA_API_SECRET_KEY;
        const cdresponse = await axiosPrivate.get(url);

        if (cdresponse.data.status === "Not Found") {
            setpageData({ dataNotFound: true })
            return
        }
        //  document.title = cdresponse.data.stock_name + "- 3M Score | Stock Scoring Model | Moat, Management & MOS score | Compare Stocks on key financial attributes | Investing checklist. ";
        let tempData = JSON.parse(JSON.stringify(cdresponse.data))
        tempData.rows = []
        let latestHeader = cdresponse.data?.columns ? cdresponse.data?.columns[cdresponse.data?.columns.length - 1] : 0
        cdresponse.data?.rows?.forEach(item => {
            if (item.name === "Promoter Indian") {
                let sortData = []
                item.shareholders?.map(shareItem => (
                    sortData.push({ name: shareItem.name, value: shareItem.data[latestHeader] })
                ))
                sortData.sort(dynamicSortDescending("value"))
                let tempItemData = JSON.parse(JSON.stringify(item))
                tempItemData.shareholders = []
                sortData.map(sortItem => {
                    item.shareholders.map(shareItem => {
                        if (sortItem.name === shareItem.name) {
                            tempItemData.shareholders.push(shareItem)
                        }
                    })
                })
                tempData.rows.push(tempItemData)
            }
        })
        cdresponse.data?.rows?.forEach(item => {
            if (item.name === "Promoter Foreign") {
                let sortData = []
                item.shareholders?.map(shareItem => (
                    sortData.push({ name: shareItem.name, value: shareItem.data[latestHeader] })
                ))
                sortData.sort(dynamicSortDescending("value"))
                let tempItemData = JSON.parse(JSON.stringify(item))
                tempItemData.shareholders = []
                sortData.map(sortItem => {
                    item.shareholders?.map(shareItem => {
                        if (sortItem.name === shareItem.name) {
                            tempItemData.shareholders.push(shareItem)
                        }
                    })
                })
                tempData.rows.push(tempItemData)
            }
        })
        cdresponse.data?.rows?.forEach(item => {
            if (item.name === "Institutions domestic") {
                let sortData = []
                item.shareholders?.map(shareItem => (
                    sortData.push({ name: shareItem.name, value: shareItem.data[latestHeader] })
                ))
                sortData.sort(dynamicSortDescending("value"))
                let tempItemData = JSON.parse(JSON.stringify(item))
                tempItemData.shareholders = []
                sortData.map(sortItem => {
                    item.shareholders?.map(shareItem => {
                        if (sortItem.name === shareItem.name) {
                            tempItemData.shareholders.push(shareItem)
                        }
                    })
                })
                tempData.rows.push(tempItemData)
            }
        })
        cdresponse.data?.rows?.forEach(item => {
            if (item.name === "Institutions foreign") {
                let sortData = []
                item.shareholders?.map(shareItem => (
                    sortData.push({ name: shareItem.name, value: shareItem.data[latestHeader] })
                ))
                sortData.sort(dynamicSortDescending("value"))
                let tempItemData = JSON.parse(JSON.stringify(item))
                tempItemData.shareholders = []
                sortData.map(sortItem => {
                    item.shareholders?.map(shareItem => {
                        if (sortItem.name === shareItem.name) {
                            tempItemData.shareholders.push(shareItem)
                        }
                    })
                })
                tempData.rows.push(tempItemData)
            }
        })
        cdresponse.data.rows?.forEach(item => {
            if (item.name === "Non-institutions") {
                let sortData = []
                item.shareholders?.map(shareItem => (
                    sortData.push({ name: shareItem.name, value: shareItem.data[latestHeader] })
                ))
                sortData.sort(dynamicSortDescending("value"))
                let tempItemData = JSON.parse(JSON.stringify(item))
                tempItemData.shareholders = []
                sortData.map(sortItem => {
                    item.shareholders?.map(shareItem => {
                        if (sortItem.name === shareItem.name) {
                            tempItemData.shareholders.push(shareItem)
                        }
                    })
                })
                tempData.rows.push(tempItemData)
            }
        })
        cdresponse.data?.rows?.forEach(item => {
            if (item.name === "Government") {
                let sortData = []
                item.shareholders?.map(shareItem => (
                    sortData.push({ name: shareItem.name, value: shareItem.data[latestHeader] })
                ))
                sortData.sort(dynamicSortDescending("value"))
                let tempItemData = JSON.parse(JSON.stringify(item))
                tempItemData.shareholders = []
                sortData.map(sortItem => {
                    item.shareholders?.map(shareItem => {
                        if (sortItem.name === shareItem.name) {
                            tempItemData.shareholders.push(shareItem)
                        }
                    })
                })
                tempData.rows.push(tempItemData)
            }
        })
        cdresponse.data?.rows?.forEach(item => {
            if (item.name === "Non-promoter non-public") {
                let sortData = []
                item.shareholders?.map(shareItem => (
                    sortData.push({ name: shareItem.name, value: shareItem.data[latestHeader] })
                ))
                sortData.sort(dynamicSortDescending("value"))
                let tempItemData = JSON.parse(JSON.stringify(item))
                tempItemData.shareholders = []
                sortData.map(sortItem => {
                    item.shareholders?.map(shareItem => {
                        if (sortItem.name === shareItem.name) {
                            tempItemData.shareholders.push(shareItem)
                        }
                    })
                })
                tempData.rows.push(tempItemData)
            }
        })

        setpageData(tempData)

    }

    function handleCollapse(key) {
        console.log(collapse.filter(a => a !== key))
        if (collapse.includes(key)) {
            setCollapse(collapse.filter(a => a !== key))
        } else {
            setCollapse(temp => [...collapse, key])
        }
    }

    const hasValue = (dataDict) => {
        let valueFound = false
        Object.keys(dataDict).map(item => {
            if (dataDict[item] !== 0) {
                valueFound = true
            }
        })
        return valueFound
    }


    function handleDownloadExcel() {

        let header = ["S. No.", "Stock Symbol", "Name", "% of Portfolio", "Activity", "Change", "Change%", "Shares", "Current Price", "Investment Value (Cr)", "52W Low", "52W High", "% Above 52W low", "Industry", "Sector"]
        let body = []

        pageData?.investments.forEach((item, index) => {
            let tempData = [index + 1]
            tempData.push(item.stock_symbol)
            tempData.push(item.name)
            tempData.push(item.pctOfProfile)
            tempData.push(item.activity)
            tempData.push(item.change)
            tempData.push(item.pctChange)
            tempData.push(item.share)
            tempData.push(item.currentPrice)
            tempData.push(item.investmentValue)
            tempData.push(item.low52)
            tempData.push(item.high52)
            tempData.push(item.pctAbove52WLow)
            tempData.push(item.industry)
            tempData.push(item.sector)
            body.push(tempData)
        })


        downloadExcel({
            fileName: "Investor",
            sheet: "Investor",
            tablePayload: {
                header,
                // accept two different data structures
                body: body,
            },
        });
    }

    const getUrl = (url) => {
        return "/Investor/" + url
    }

    useEffect(() => {
        companyDetails()
    }, [anuual, companySymbol])


    return (
        <div style={{ overflowY: "auto", padding: "10px 5px", minHeight: "550px" }}>
            {Object.keys(pageData)?.length !== 0 &&
                <>
                <section className="optionsFinDataMobile">
                        <div className="leftAlign growthCompanyName" style={{ paddingLeft: "0px", fontWeight: "600" }}>
                            {pageData.company_name}
                        </div>
                        <div className="rightAlign">
                                <div style={{ display: "flex", fontSize: "9px", cursor: "pointer", width: "90px", paddingRight: "10px"}}>
                                    <div onClick={() => setAnnual(false)} style={anuual ? { backgroundColor: "rgb(221, 219, 240)", padding: "5px 10px", borderTopLeftRadius: "5px", borderBottomLeftRadius: "5px", width: "90px" } : { backgroundColor: "rgb(0, 0, 0)", padding: "5px 10px", color: "white", borderTopLeftRadius: "5px", borderBottomLeftRadius: "5px", width: "90px" }}>Quarterly</div>
                                    <div onClick={() => setAnnual(true)} style={!anuual ? { backgroundColor: "rgb(221, 219, 240)", padding: "5px 10px", borderTopRightRadius: "5px", borderBottomRightRadius: "5px", width: "90px" } : { backgroundColor: "rgb(0, 0, 0)", padding: "5px 10px", color: "white", borderTopRightRadius: "5px", borderBottomRightRadius: "5px", width: "90px" }}>Annual</div>
                                </div>
                        </div>
                    </section>

                    <div style={{ backgroundColor: "white", borderRadius: "10px", padding: "10px", overflowX: "auto" }}>
                        <div className="leftAlign growthCompanyName" style={{ padding: "5px 0px", fontWeight: "600", textAlign: "left", fontSize: "10px" }}>
                            Shareholding Pattern
                    </div>
                        <table className="PeersTable finData" style={{ backgroundColor: "white", fontSize: "9px"}}>
                            <tbody>
                                <tr>
                                    <td className="PeerColumnHeading PeerTabledataCenter"></td>
                                    {pageData?.columns?.map(item => (
                                        <td className="PeerColumnHeading PeerTabledataCenter" style={{ textAlign: "center" }}>{item}</td>
                                    ))
                                    }
                                </tr>
                            </tbody>
                            <tbody>
                                {pageData?.rows?.map((dataKey, index) => (
                                    <>
                                        <tr>
                                            <td className="PeerTabledataCenter SubHeader"
                                                style={{ textAlign: "left", fontSize: "9px", whiteSpace: "nowrap", fontWeight: "500" }}>
                                                <div style={{ display: "flex", columnGap: "5px", cursor: "pointer" }} onClick={() => handleCollapse(dataKey.name)}>
                                                    <div style={collapse.includes(dataKey.name) ? { fontWeight: "600" } : { fontWeight: "500" }}>{dataKey.name}</div>
                                                    {!collapse.includes(dataKey.name) ?
                                                        <div style={{ paddingTop: "1px", color: "blue", fontWeight: "600" }}>+</div>
                                                        :
                                                        <div style={{ paddingTop: "1px", color: "blue", cursor: "pointer", fontWeight: "600" }} >-</div>
                                                    }
                                                </div>
                                            </td>
                                            {pageData.columns.map(dataItem => (
                                                <td className="PeerTabledataCenter SubHeader" style={collapse.includes(dataKey.name) ? { fontWeight: "600" } : { fontWeight: "400" }}>{dataKey.data[dataItem]} %</td>
                                            ))}
                                        </tr>
                                        {collapse.includes(dataKey.name) && dataKey.shareholders !== undefined && dataKey.shareholders.map((investorData, index) => (
                                            <>
                                                {hasValue(investorData.data) && <tr>
                                                    <td className={index % 2 === 0 ? "PeerTabledataLeft SubHeader OddDiv" : "PeerTabledataLeft SubHeader"} style={{ textAlign: "left", paddingLeft: "30px", maxWidth: "300px", whiteSpace: "nowrap" }}><a href={getUrl(investorData.shareholder_id)} target="_blank" style={{ textDecoration: "None" }}>{investorData.name}</a></td>
                                                    {pageData.columns.map(dataItem => (
                                                        <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"}>{investorData.data[dataItem] !== 0 ? investorData.data[dataItem] : ""}</td>
                                                    ))}
                                                </tr>}
                                            </>
                                        ))
                                        }
                                    </>
                                ))}
                                {(pageData.dataNotFound === true || pageData?.rows?.length === 0) &&
                                    <tr>
                                        <td colspan={pageData.columns?.length + 1}>Data not found</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                    <div style={{ backgroundColor: "white", borderRadius: "10px", padding: "10px", marginTop: "20px", overflowX: "auto" }}>
                        <div className="leftAlign growthCompanyName" style={{ padding: "5px 0px", fontWeight: "600", textAlign: "left", fontSize: "9px" }}>
                            Structure Summaries
                    </div>
                    <table className="PeersTable finData" style={{ backgroundColor: "white", fontSize: "9px" }}>
                            <tbody>
                                <tr>
                                    <td className="PeerColumnHeading PeerTabledataCenter" style={{ minWidth: "180px" }}></td>
                                    {pageData?.columns?.map(item => (
                                        <td className="PeerColumnHeading PeerTabledataCenter" style={{ textAlign: "center" }}>{item}</td>
                                    ))
                                    }
                                </tr>
                            </tbody>
                            <tbody>
                                {pageData?.structure_summaries?.map((dataKey, index) => (
                                    <>
                                        <tr>
                                            <td className={index % 2 === 0 ? "SubHeader OddDiv" : "SubHeader"} style={{ textAlign: "left", fontSize: "9px", whiteSpace: "nowrap", fontWeight: "500" }}>{dataKey.name}</td>
                                            {pageData.columns?.map(dataItem => (
                                                <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"} style={dataKey.name === "Pledged shares %" && dataKey.data[dataItem] > 0 ? { color: "#ff0000" } : { color: "black" }}>{dataKey.data[dataItem].toLocaleString('en-IN')} </td>
                                            ))}
                                        </tr>

                                    </>
                                ))}
                                {pageData.dataNotFound === true &&
                                    <tr>
                                        <td>Data not found</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>


                    <div style={{ backgroundColor: "white", borderRadius: "10px", padding: "10px", marginTop: "20px", overflowX: "auto" }}>
                        <div className="leftAlign growthCompanyName" style={{ padding: "5px 0px", fontWeight: "600", textAlign: "left", fontSize: "9px" }}>
                            Declarations
                    </div>
                        <table className="PeersTable finData" style={{ backgroundColor: "white", fontSize: "9px"}}>
                            <tbody>
                                <tr>
                                    <td className="PeerColumnHeading PeerTabledataCenter"></td>
                                    {pageData?.columns?.map(item => (
                                        <td className="PeerColumnHeading PeerTabledataCenter" style={{ textAlign: "center" }}>{item}</td>
                                    ))
                                    }
                                </tr>
                            </tbody>
                            <tbody>
                                {pageData?.declarations?.map((dataKey, index) => (
                                    <>
                                        <tr>
                                            <td className={index % 2 === 0 ? "SubHeader OddDiv" : "SubHeader"} style={{ textAlign: "left", fontSize: "9px", whiteSpace: "nowrap", fontWeight: "500" }}>{dataKey.name}</td>
                                            {pageData.columns?.map(dataItem => (
                                                <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"} style={dataKey.data[dataItem] === "Yes" ? { color: "#ff0000" } : { color: "black" }}>{dataKey.data[dataItem]} </td>
                                            ))}
                                        </tr>

                                    </>
                                ))}
                                {pageData.dataNotFound === true &&
                                    <tr>
                                        <td>Data not found</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                </>
            }
            {Object.keys(pageData).length === 0 &&
                <Loading />
            }
        </div>
    );
}
export default CompanyMobile;